/* eslint-disable @typescript-eslint/no-unsafe-function-type */
type WindowWithDataLayer = Window & {
  gtag: Function;
  grecaptcha: {
    execute: Function;
  };
};

declare const window: WindowWithDataLayer;

const grecaptcha = window.grecaptcha || {};

const TARGET_ID = import.meta.env
  .VITE_REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID!;

function gtag(...params: any[]) {
  window.gtag?.(...params);
}

async function getGoogleAnalyticsClientId(): Promise<string> {
  return new Promise((resolve) => {
    let resolved = false;

    try {
      window.gtag('get', TARGET_ID, 'client_id', (clientId: string) => {
        if (!resolved) {
          resolved = true;
          resolve(clientId || '');
        }
      });
    } catch {
      if (!resolved) resolve('');
    }

    setTimeout(() => {
      if (!resolved) {
        resolved = true;
        resolve('');
      }
    }, 500);
  });
}

async function getGoogleAnalyticsSessionId(): Promise<string> {
  return new Promise((resolve) => {
    let resolved = false;
    try {
      window.gtag('get', TARGET_ID, 'session_id', (sessionId: string) => {
        if (!resolved) {
          resolved = true;
          resolve(sessionId || '');
        }
      });
    } catch {
      if (!resolved) resolve('');
    }

    setTimeout(() => {
      if (!resolved) {
        resolved = true;
        resolve('');
      }
    }, 500);
  });
}

function sendEvent(eventName: string, params: Record<string, any> = {}) {
  gtag('event', eventName, params);
}

async function reportSignup() {
  try {
    const gClientId = await getGoogleAnalyticsClientId();
    if (gClientId) {
      sendEvent('web_registration', { client_id: gClientId });
    }
  } catch (err) {
    console.log(err);
  }
}

async function executeCaptcha() {
  return new Promise<string>((resolve, reject) => {
    grecaptcha
      .execute(import.meta.env.VITE_REACT_APP_GOOGLE_RECAPTCHA_KEY as string, {
        action: 'submit',
      })
      .then((token: string) => {
        resolve(token);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
}

export {
  gtag,
  getGoogleAnalyticsClientId,
  getGoogleAnalyticsSessionId,
  sendEvent,
  reportSignup,
  executeCaptcha,
};
